import createWrappedField from './createWrappedField'
import TG from '../Toggle'

export default createWrappedField({
  Component: TG,
  name: 'DDIToggle'
})
